<!-- Descomentar el spinner cuando podamos convertir a standalone -->
<!-- <app-spinner></app-spinner> -->
<!-- <div class="safe-area">
    <app-header *ngIf="showHeader"></app-header>
    <main class="content-wrapper" [ngClass]="{'ios-wrapper': isIos}" role="main" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
    <app-sctoll-to-top></app-sctoll-to-top>
    <app-footer *ngIf="showFooter"></app-footer>
</div> -->


<app-spinner></app-spinner>
<div class="safe-area-ios" *ngIf="isIos"></div>
<app-header *ngIf="showHeader"></app-header>
<main class="content-wrapper flex-grow-1" [ngClass]="{'mnc-wrapper': isIos}" role="main" tabindex="-1">
    <router-outlet></router-outlet>
  </main>
  <app-sctoll-to-top></app-sctoll-to-top>
  <app-footer *ngIf="showFooter"></app-footer>